module.exports = __webpack_public_path__ + "img/ic-enlace.74c50e2a.png";